import { render, staticRenderFns } from "./AppointmentDontWork.vue?vue&type=template&id=82f2efca&"
import script from "./AppointmentDontWork.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppointmentDontWork.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82f2efca')) {
      api.createRecord('82f2efca', component.options)
    } else {
      api.reload('82f2efca', component.options)
    }
    module.hot.accept("./AppointmentDontWork.vue?vue&type=template&id=82f2efca&", function () {
      api.rerender('82f2efca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentPage/components/common/AppointmentDontWork.vue"
export default component.exports